import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface PinPatientResponse {
  patientIds: string[];
  userIds: number[];
}

interface PinPatientParams {
  userId?: string;
  patientId?: string;
}

export const usePinPatient = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<PinPatientResponse, PinPatientParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Provider.AsyncMessageDashboard.PIN_PATIENT(patientId),
      mutationFn: (params) =>
        axiosInstance.post(
          "/new-api/async-messaging/pinned-patients/pin",
          params,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["provider", "async-message-dashboard", "pinned"],
        });
      },
    },
  });
};
